module.exports = __webpack_public_path__ + "static/media/provider.0775327b.svg";